import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const useStyles = makeStyles({
      root: {
            '&$checked': {
                  color: '#000'
            }
      },
      checked: {},
      wrap: {
            width: '100%',
            display: 'flex',
            flexDirection: 'row-reverse',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginLeft: 0
      },
      label: {
            fontSize: '1rem'
      }
});

const SizeFilter = ({ sizes, loading, changeChecked, type }) => {
      const classes = useStyles();

      return (
            <>
                  {!loading
                        ? sizes.map((size, index) => (
                                <FormControlLabel
                                      classes={{
                                            label: classes.label,
                                            root: classes.wrap
                                      }}
                                      key={index}
                                      control={
                                            <Checkbox
                                                  classes={{
                                                        checked: classes.checked,
                                                        root: classes.root
                                                  }}
                                                  size="small"
                                                  checked={size.checked}
                                                  onChange={() =>
                                                        changeChecked(
                                                              size.id,
                                                              type
                                                        )
                                                  }
                                                  inputProps={{
                                                        'aria-label':
                                                              'checkbox with small size'
                                                  }}
                                            />
                                      }
                                      // label={`${ size.title } (${size.products})`}
                                      label={`${size.title}`}
                                />
                          ))
                        : ''}
            </>
      );
};
export default SizeFilter;
